import { getEssayByUser } from '../../../core/queries/essays-queries/essayFunction';
import { useGenericQuery } from '../../../core/api/reactQuery';
import { IEssay } from '../../../core/models/essay';

export function useUserEssay(slug:string, cb?: (body: IEssay) => void) {
  const {
    data,
    isError,
    error,
    isPending
  } = useGenericQuery(['userEssay', slug], () => getEssayByUser(slug), cb as (body: IEssay) => void);

  return {
    isError,
    isPending,
    error,
    data
  }
}
